import React, { Fragment, Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import
{
    Card, CardBody, Col, UncontrolledTooltip, Button, Container, FormGroup, Row, Label, Input,
    ModalBody, Modal, ModalHeader, Alert, ModalFooter, NavItem, NavLink, Nav, TabContent, TabPane, Form
} from 'reactstrap';
import '../../assets/DVTools/styles/Style.css';
import Player from '../../helpers/Components/VideoPlayerComponent/index';
import IMG01 from '../../assets/DVTools/images/ChannelMediaThumbs/Video-Icon.png';

import { Splitter } from '@progress/kendo-react-layout';
import { faCog, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as  PlayerUtils from '../PlayerUI/js/index';
import * as  PlayerUtils2 from '../PlayerUI/js/index2';
import * as  VotesUtils from '../PlayerUI/js/video_votes';
import * as  PlayerDesignUtils from '../PlayerUI/js/playerPageDesignSettings';
import * as  CommentsUtils from '../PlayerUI/js/video_comments';
import * as  TicketsUtils from '../PlayerUI/js/video_tickets';
import * as  DownloadPaymentUtils from '../PlayerUI/js/video_download_payment';
import * as indexFunctionUtils from '../PlayerUI/index_functions';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import { toast, Slide } from 'react-toastify';
import ModalDrawer from './UpdateSettings/ModalDrawer';
import CustomeSweetAlert from '../../helpers/Components/CustomeSweetAlert';
import GoogleLogin from 'react-google-login';
import RightPart from './right_part';
import CommentsPart from './comments_part';
import TicketsComponent from '../PlayerUI/tickets_part';
import Ionicon from 'react-ionicons';
import BuyWithCreditCard from '../../helpers/Components/PayWithCreditCard';
import { Icon } from '@iconify/react';
import logoPaypal from '@iconify/icons-ion/logo-paypal';
import ReactGA from 'react-ga';
import ReactHlsPlayer from 'react-hls-player';
import classnames from 'classnames';
//import PhoneInput from 'react-phone-input-2';
ReactGA.initialize('UA-64905417-1');
ReactGA.pageview(window.location.pathname + window.location.search);

export default class PlayerUI extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            activeTab: '',
            commentsActiveTab: '',
            showEditDiv: false,
            isHLSPlayer: false,
            videoData: {
                videoGuid: "",
                videoType: "",
                video_title: "",
                video_desc: "",
                channelGuid: "",
                error_message: "",
                donation_type: "",
                allow_donation_and_account_not_valid: false,
                show_donation_popup: false,
                video_references: [],
                video_bookmarks: [],
                video_comments: [],
                logo_src: IMG01,
                token_status: "",
            },
            videoDesignSettingDiv: {},
            blocking: false,
            blocking2: true,
            openDrawer: false,
            loaderType: 'ball-grid-beat',
            dimensions: {},
            nestedPanes: [{ min: "50%", resizable: true, collapsible: false, }, { size: '15%', min: '10%', resizable: true, collapsible: false }],
            password: "",
            isPasswordCorrect: false,
            ToastMessage: "All good",
            ToastAlertType: "info",
            showCustomAlert: false,
            loginToAccoiuntUrl: "#",
            customAccountInfo: null,
            for_edit_comments: [],
            helnix_cookies: null,
            google_account_info: null,
            showStillWatchingAlert: false,
            showEndWatchingAlert: false,
            is_watching: true,
            timerSecondes: 15,
            showTicketPopup: false,
            showPaypalButton: false,
            listTickets: [],
            isFirstTimeLoadPage: true,
            showDonatePopup: false,
            donationMoney: 0,
            DonationModalblocking: false,
            auto_start: true,
            showDownloadPopup: false,
            downloadVideoPrice: 19.99,
            buy_download_video_email: "",
            BuyDownloadActiveTab: "1",
            downloadVideoPaymentSuccess: false
        };
        console.log("window.innerHeight = ", window.innerHeight);
        console.log("window.innerHeight *.75 = ", window.innerHeight * .75);
        this.toggle = this.toggle.bind(this);
        this.commentsToggle = this.commentsToggle.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.submitVideoPassword = this.submitVideoPassword.bind(this);
    }
    //getText = () =>
    //{
    //    const { text, a, b, c,e , d } = Dictaphone();
    //    debugger
    //}
    onChangePassword(e)
    {
        this.setState({ videoPassword: e.target.value })
    }
    submitVideoPassword()
    {
        if (this.state.videoPassword !== "")
        {
            this.setState({ blocking: true }, () => { PlayerUtils.video_password_click(this, this.state.videoPassword); })
        }
        else
        {
            this.showToast("Incorrect password", "error");
        }
    }
    onNestedChange = (event) =>
    {
        this.setState({
            nestedPanes: event.newState
        });
    }
    toggleBlocking = (blocking) =>
    {
        this.setState({ blocking: blocking });
    }
    componentDidMount()
    {
        var referrer = document.referrer;
        console.log("referrer url ", referrer);
        indexFunctionUtils.index_ready(this);
        //this.getText();
    }
    loadData = () =>
    {
        indexFunctionUtils.loadData(this);
    }
    toggle(tab)
    {
        if (this.state.activeTab !== tab)
        {
            if (tab === "3")
            {
                PlayerDesignUtils.get_vod_bookmarks(this);
            }
            else if (tab === "1")
            {
                if (this.RightPartComponent)
                {
                    this.RightPartComponent.loadChat();
                }
            }
            this.setState({
                activeTab: tab
            });
        }
    }
    commentsToggle(tab)
    {
        if (this.state.commentsActiveTab !== tab)
        {
            this.setState({
                commentsActiveTab: tab
            });
        }
    }
    onEditBtunClick = () =>
    {
        this.setState({
            openDrawer: true,
        });
    }
    onCloseDrawerClick = () =>
    {
        this.setState({
            openDrawer: false,
        });
    }
    onBackBtnClick = () =>
    {
        this.setState({ showEditDiv: false, })
    }
    getSnapshotBeforeUpdate()
    {
        if (this.PlayerDiv !== undefined && this.PlayerDiv !== null)
        {
            let width = this.PlayerDiv.offsetWidth;
            let height = this.PlayerDiv.offsetHeight;
            console.log("height = ", height)
            return { width };
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if (window.FB)
        {
            window.FB.XFBML.parse();
        }
        if (this.PlayerDiv !== undefined && this.PlayerDiv !== null)
        {
            console.log("this.PlayerDiv.offsetWidth = ", this.PlayerDiv.offsetWidth)
            if (this.state.dimensions.width !== this.PlayerDiv.offsetWidth)
            {
                this.setState({
                    dimensions: {
                        width: this.PlayerDiv.offsetWidth,
                    },
                })
            }
        }
    }
    showToast(msg, AlertType)
    {
        this.toastId = toast(msg, {
            transition: Slide,
            closeButton: true,
            autoClose: 5000,
            position: 'bottom-center',
            type: AlertType,
        });
    }
    onClickRefUrl = (url) =>
    {
        this.setState({
            divShowPdf: true,
            pdfUrl: url,
        })
    }
    closeShowPdf = () =>
    {
        this.setState({ divShowPdf: false, })
    }
    onBookmarkClick = (time) =>
    {
        this.PlayerItem.onSeekButtonClick(time);
    }
    onTypeComment = (e) =>
    {
        var keyCode = e.keyCode;
        var shiftKey = e.shiftKey;
        this.setState({
            comment_text: e.target.value
        }, () =>
        {
            CommentsUtils.add_new_comment(this, keyCode, shiftKey);
        })
    }
    showMoreComments = () =>
    {
        CommentsUtils.load_more_comments(this);
    }
    onEditCommentClick = (comment_guid) =>
    {
        indexFunctionUtils.onEditCommentClick(this, comment_guid);
    }
    onCommentKeyUp = (e, item) =>
    {
        indexFunctionUtils.onCommentKeyUp(this, e, item);
    }
    onCommentValueChanged = (e, item) =>
    {
        indexFunctionUtils.onCommentValueChanged(this, e, item);
    }
    cancelCommentChange = (item, isChanged) =>
    {
        indexFunctionUtils.cancelCommentChange(this, item, isChanged);
    }
    onDeleteCommentClick = (item_guid) =>
    {
        this.setState({ comment_guid_to_delete: item_guid, showCustomAlert: true, })
    }
    onDeleteComment = () =>
    {
        CommentsUtils.delete_comment(this, this.state.comment_guid_to_delete);
    }
    onCancelDeleteComment = () =>
    {
        this.setState({ comment_guid_to_delete: '', showCustomAlert: false, })
    }
    onLoginButtonClick = () =>
    {
    }
    onShowGoogleLogin = () => { this.setState({ showLoginCustomAlert: true, }) }
    onShowChatGoogleLogin = (rightComponent, messageEvent) =>
    {
        this.setState({ showChatLoginCustomAlert: true, rightComponent: rightComponent, messageEvent: messageEvent, })
    }
    onCancelLogin = () => { indexFunctionUtils.onCancelLogin(this) }
    onCancelChatLogin = () => { indexFunctionUtils.onCancelChatLogin(this) }
    onSuccessresponseGoogle = (response) =>
    {
        indexFunctionUtils.onSuccessresponseGoogle(this, response);
    }
    onErrorresponseGoogle = (response) =>
    {
        console.log("on error", response);
    }
    onChatSuccessresponseGoogle = (response) =>
    {
        indexFunctionUtils.onChatSuccessresponseGoogle(this, response);
    }
    onChatErrorresponseGoogle = (response) =>
    {
        console.log("on error", response);
    }

    onChangeSetting = (data) =>
    {
        this.setState(prevState => ({
            videoDesignSettingDiv: {
                ...prevState.videoDesignSettingDiv,
                show_logo: data.show_logo,
                logo_src: data.logo_src,
                videoLogoFile: data.videoLogoFile,
                logo_guid: data.logo_guid,
                //logoPreviewUrl: data.logoPreviewUrl,
                videoLogo: data.videoLogo,
                show_homepage: data.show_homepage,
                show_references: data.show_references,
                show_bookmarks: data.show_bookmarks,
                show_chat: data.show_chat,
                show_download: data.show_download,
                show_comments: data.show_comments,
                show_fb_comments: data.show_fb_comments,
                homepage_link: data.homepage_link,
                is_dark: data.is_dark,
                hls_low_delay: data.hls_low_delay,
                visitor_timeout: data.visitor_timeout
            }
        }))
    }
    onLogoError = () =>
    {
        //if (this.state.customAccountInfo !== null)
        //{
        //    this.imgLogo.src = IMG01;
        //}
        //else
        {
            this.imgLogo.src = "";
            this.setState(prevStte => ({
                videoData: {
                    ...prevStte.videoData,
                    logo_src: "",
                }

            }))
        }
    }
    load_video_info = () =>
    {
        PlayerUtils.load_video_info(this);

    }
    onUserStillWatching = () =>
    {
        this.setState({ showStillWatchingAlert: false, is_watching: true }, () =>
        {
            PlayerDesignUtils.reset_timer(this);
        })
    }
    showBuyTicketPart = () =>
    {
        TicketsUtils.load_tickets(this);

    }
    onClickApplyButton = () =>
    {
        TicketsUtils.apply_token(this);
    }
    onChangeTokenValue = (value, click_apply_token) =>
    {
        this.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                video_token: value
            }
        }), () =>
        {
            if (click_apply_token === true)
            {
                TicketsUtils.apply_token(this);
            }
        })
    }
    onShowDonationClick = () =>
    {
        if (document.getElementById("player-button"))
        {
            document.getElementById("player-button").style.zIndex = 10;
        }
        this.setState({ showDonatePopup: true });
    }
    onChangeDonationMoneyValue = (e) =>
    {
        this.setState({ donationMoney: e.target.value })
    }
    payDonationByCreditCard = (cardInfo) =>
    {
        if (this.state.donationMoney === 0)
        {
            this.showToast("Please enter money value", "error");
        }
        else
        {
            this.setState({ card_info: cardInfo }, () =>
            {
                PlayerUtils2.pay_donation_with_creditcard(this);
            })
        }
    }
    onCloseCreditCardPopup = () =>
    {
        if (document.getElementById("player-button"))
        {
            document.getElementById("player-button").style.zIndex = 111111;
        }
        //if (this.state.videoData.video_donation_transaction)
        //{
        //    window.location = window.location.href.replace("&ppt=" + this.state.videoData.video_donation_transaction, "");
        //}
        this.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                video_donation_transaction: "",
            },
            showDonatePopup: false, donationMoney: 0, donationMessage: "",
        }))

    }
    onCloseDownloadPayCreditCardPopup = () =>
    {
        this.setState({ showDownloadPopup: false })
    }
    onChangeDonationMessage = (e) =>
    {
        this.setState({ donationMessage: e.target.value })
    }
    payDonationWithPaypal = () =>
    {
        if (this.state.donationMoney === 0)
        {
            this.showToast("Please enter money value", "error");
        }
        else
        {
            PlayerUtils2.payDonationWithPaypal(this);
        }

    }
    payDownloadvideoWithPaypal = () =>
    {
        if (!this.state.buy_download_video_email)
        {
            this.showToast("Please enter your email");
        }
        else
        {
            PlayerUtils2.payDownloadVideoWithPaypal(this);
        }
    }
    onShowAddPaypalButton = () =>
    {
        if (document.getElementById("player-button"))
        {
            document.getElementById("player-button").style.zIndex = 10;
        }
        this.setState({ ShowAddPaypalButtonPopup: true })
    }
    onCloseAddPaypalButtonPopup = () =>
    {
        this.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
            },
            ShowAddPaypalButtonPopup: false
        }))

    }
    onChangePaypalButtonCodeValue = (e) =>
    {
        var code = e.target.value;
        this.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                paypalButtonCode: code
            }
        }))
    }
    onChangePaypalButtonCodeTitleValue = (e) =>
    {
        var title = e.target.value;
        this.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                paypalButtonCodeTitle: title
            }
        }))
    }
    onUpdatePaypalButtonCodeClick = () =>
    {
        PlayerUtils2.updatePaypalButtonCode(this);
    }
    onClearPaypalButtonCode = () =>
    {
        this.setState(prevState => ({
            videoData: {
                ...prevState.videoData,
                paypalButtonCode: ""
            }
        }), () =>
        {
            //PlayerUtils2.updatePaypalButtonCode(this);
        })
    }
    openDownloadPayPopup = () =>
    {
        //DownloadPaymentUtils.get_account_payment_data(this);
        if (document.getElementById("player-button"))
        {
            document.getElementById("player-button").style.zIndex = 10;
        }
        this.setState({ showDownloadPopup: true })
    }
    payByCreditCard = (card_info) =>
    {
        this.setState({ card_info: card_info }, () =>
        {
            if (this.state.buy_download_video_email === "")
            {
                this.showToast("Please enter your email", "error");
            }
            else
            {
                DownloadPaymentUtils.buy_download_video_with_creditcard_for_mrl_payment(this);
            }
        })

    }
    payByCreditCardForUserPayment = (card_info) =>
    {
        this.setState({ card_info: card_info }, () =>
        {
            if (this.state.buy_download_video_email === "")
            {
                this.showToast("Please enter your email", "error");
            }
            else
            {
                DownloadPaymentUtils.buy_download_video_with_creditcard(this);
            }
        })

    }
    onChangeEmail = (e) =>
    {

        this.setState({ buy_download_video_email: e });
    }
    onChangePurchaseEmail = (e) =>
    {
        this.setState({ buy_download_video_email: e.target.value });
    }
    buyDownloadToggle = (e) =>
    {
        this.setState({ BuyDownloadActiveTab: e, download_video_error: "" })
    }
    checkPuerchaseByEmail = () =>
    {
        DownloadPaymentUtils.check_puerchase_by_email(this);
    }
    urlify = (text) =>
    {
        var all_words = text.split(' ');
        var urlRegex = "(https?: \/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})";
        return (
            <div >
                {all_words.map((word, i) =>
                {
                    if (all_words[i].match(urlRegex) && all_words[i].indexOf("http") > -1)
                    {
                        if (all_words[i].indexOf("https") > -1)
                        {
                            return <span> < a target="_blank" href={all_words[i]} > {all_words[i].replace("https://", "")}</a> </span>;
                        }
                        else
                        {
                            return <span> < a target="_blank" href={all_words[i]} > {all_words[i].replace("http://", "")}</a> </span>;
                        }
                    }
                    else if (all_words[i].match(urlRegex) && all_words[i].indexOf("http") == -1)
                    {
                        return <span> < a target="_blank" href={"https://" + all_words[i]} > {all_words[i]}</a> </span>;
                    }
                    else if (all_words[i].indexOf(".com") > -1 && all_words[i].indexOf("http") == -1)
                    {
                        return <span> < a target="_blank" href={"https://" + all_words[i]} > {all_words[i]}</a> </span>;
                    }
                    else if (all_words[i].indexOf(".com") > -1 && all_words[i].indexOf("http") > -1)
                    {
                        return <span> < a target="_blank" href={all_words[i]} > {all_words[i]}</a> </span>;
                    }
                    else return all_words[i] + " ";
                })}
            </div>
        );
    }
    onCloseVotePopup = () =>
    {
        this.setState({ voter_name: "", voter_email: "", voter_phone: "", artist_name: "", showVotePopup: false })
    }
    onVoteClick = () =>
    {
        if (!this.state.voter_name)
        {
            this.showToast("Please enter your name", "error")
        }
        else if (!this.state.voter_email)
        {
            this.showToast("Please enter your email", "error")
        }
        else if (!new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.voter_email))
        {
            this.showToast("Please enter valid email address", "error")
        }
        else if (this.state.voter_phone && !new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i).test(this.state.voter_phone))
        {
            this.showToast("Please enter valid phone address", "error")
        }

        else if (!this.state.artist_name)
        {
            this.showToast("Please enter artist name", "error")
        }
        else
        {
            VotesUtils.save_vote(this);
        }
    }
    onChangePhoneNumber = (e) =>
    {
        var text = e.target.value.replace(/\D/g, '');
        this.setState({ voter_phone: text })
    }
    render()
    {
        if (this.state.videoData.error_message !== "")
        {
            return (
                <Fragment>
                    <ReactCSSTransitionGroup
                        component="div"
                        transitionName="TabsAnimation"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnter={false}
                        transitionLeave={false}>
                        <BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type={this.state.loaderType} />}>
                            <Col md="10" className="mx-auto">
                                <Card tabs="true" className="mb-3">
                                    <CardBody>
                                        <table style={{ width: "100%" }}>
                                            <tr >
                                                <td style={{ width: "2%" }}>
                                                    <img src={IMG01} width="100px" height="80px" />
                                                </td>
                                                <td style={{ width: "96%", verticalAlign: "top" }}>
                                                    <span style={{ marginLeft: "2%", fontSize: "14px" }}>{this.state.videoData.video_title}</span><br />
                                                    {this.urlify(this.state.videoData.video_desc)}
                                                </td>
                                            </tr>
                                        </table>
                                        <div style={{ marginTop: "5%" }}>
                                            <h4 >{this.state.videoData.error_message}</h4>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </BlockUi>
                    </ReactCSSTransitionGroup>
                </Fragment >
            );
        }

        else if (this.state.showTicketPopup === true && this.state.videoData.token_status !== "valid")
        {
            return (
                <Fragment>
                    <ReactCSSTransitionGroup
                        component="div"
                        transitionName="TabsAnimation"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnter={false}
                        transitionLeave={false}>
                        <BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type={this.state.loaderType} />}>
                            <TicketsComponent videoData={this.state.videoData} showPaypalButton={this.state.showPaypalButton}
                                showBuyTicketPart={this.showBuyTicketPart} listTickets={this.state.listTickets}
                                onClickApplyButton={this.onClickApplyButton}
                                onChangeTokenValue={this.onChangeTokenValue} toggleBlocking={this.toggleBlocking}
                                playerComponent={this} new_ticket_info={this.state.new_ticket_info} />

                        </BlockUi>
                    </ReactCSSTransitionGroup>
                </Fragment>
            );
        }
        else if (this.state.password === "false" && this.state.isPasswordCorrect === true && this.state.is_embed !== true)
        {
            var facebook_comments_url = "";
            if (this.state.videoData.channelGuid !== "")
            { facebook_comments_url = window.location.protocol + "//" + window.location.hostname + "//show?vg=" + this.state.videoData.videoGuid + "&vt=" + this.state.videoData.videoType + "&ch=" + this.state.videoData.channelGuid + "&fb=true"; }
            else
            {
                facebook_comments_url = window.location.protocol + "//" + window.location.hostname + "//show?vg=" + this.state.videoData.videoGuid + "&vt=" + this.state.videoData.videoType + "&ch=" + this.state.videoData.channelGuid + "&fb=true";
            }

            return (
                <Fragment>
                    <ReactCSSTransitionGroup
                        component="div"
                        transitionName="TabsAnimation"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnter={false}
                        transitionLeave={false}
                    >
                        <BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type={this.state.loaderType} />}>
                            <Container fluid style={this.state.videoData.is_dark === true ? { backgroundColor: "#1f1f1f", color: "white" } : null}>

                                <Row>
                                    <div className="playerHeader" style={this.state.videoData.is_dark === true ? { backgroundColor: "#1f1f1f", color: "white", marginBottom: ".5%" } : { marginBottom: ".5%" }}>
                                        {this.state.videoData.show_homepage === true ?
                                            <a href={this.state.videoData.homepage_link} title="HomePage" target="_blank" style={{ marginRight: "1%" }}>
                                                {/*<Image fallbackSrc={IMG01} width={30} Title="HomePage" src={this.state.videoData.is_dark === true ? HomePageLogoWhite : HomePageLogo} />*/}
                                                <Ionicon fontSize="30px" color="#8b8989" icon="md-home" />
                                            </a> : null}
                                        {this.state.videoData.is_owner === true ?
                                            <Fragment> <Button className="btn-open-options" style={{ marginRight: "1%" }} id="TooltipPaypal" color="secondary" onClick={this.onShowAddPaypalButton}>
                                                {/*<FontAwesomeIcon icon={faPlus} color="#573a04" fixedWidth={false} size="lg" />*/}
                                                {/*<Ionicon fontSize="30px" color="#8b8989" icon="logo-paypal" />*/}
                                                <Icon icon={logoPaypal} style={{ fontSize: "20px" }} />
                                            </Button>
                                                <UncontrolledTooltip placement="top" target={'TooltipPaypal'}>
                                                    Paypal Button
                                                </UncontrolledTooltip> </Fragment> : null}
                                        {this.state.videoData.is_owner === true ?
                                            <Fragment> <Button className="btn-open-options" style={{ marginRight: "2.3%" }} id="TooltipDemo" color="warning" onClick={this.onEditBtunClick}>
                                                <FontAwesomeIcon icon={faCog} spin color="#573a04" fixedWidth={false} size="lg" />
                                            </Button>
                                                <UncontrolledTooltip placement="top" target={'TooltipDemo'}>
                                                    Video Settings
                                                </UncontrolledTooltip> </Fragment> : null}


                                    </div>
                                </Row>

                                <Row style={{ paddingRight: "2%", paddingLeft: "2%" }}>
                                    {this.state.showSplitter === true ? <Splitter
                                        panes={this.state.nestedPanes}
                                        onChange={this.onNestedChange}
                                        style={{ top: "2%" }}>
                                        <div className="pane-content" ref={input => this.PlayerDiv = input}>



                                            {this.state.isHLSPlayer === true ?
                                                <ReactHlsPlayer
                                                    src={this.state.videoData.video_url}
                                                    autoPlay={false}
                                                    controls={true}
                                                    width={this.state.dimensions.width}
                                                    height={(window.innerHeight * .75) + "px"}
                                                /> :
                                                <Player videoUrl={this.state.videoData.video_url} hlsStartPosition={this.state.videoData.hls_low_delay}
                                                    vwidth={this.state.dimensions.width} vheight={(window.innerHeight * .75) + "px"} ref={input => this.PlayerItem = input}
                                                    Adsources={this.state.videoData.Adsources} special_parameters={this.state.videoData.special_parameters}
                                                    isYoutube={this.state.videoData.isYoutube} CaptionSrc={this.state.videoData.video_vtt} auto_start={this.state.auto_start}
                                                />
                                            }
                                        </div>

                                        <RightPart ref={i => { this.RightPartComponent = i }} videoData={this.state.videoData} activeTab={this.state.activeTab} toggle={this.toggle}
                                            divShowPdf={this.state.divShowPdf} pdfUrl={this.state.pdfUrl} closeShowPdf={this.closeShowPdf}
                                            onClickRefUrl={this.onClickRefUrl} onBookmarkClick={this.onBookmarkClick}
                                            onShowGoogleLogin={this.onShowChatGoogleLogin} chat_user_info={this.state.google_account_info} />
                                    </Splitter> : <div style={{ width: "100%" }} ref={input => this.PlayerDiv = input}>
                                        {this.state.videoData.video_url !== undefined ?

                                            <div>
                                                {this.state.isHLSPlayer === true ?
                                                    <ReactHlsPlayer
                                                        src={this.state.videoData.video_url}
                                                        autoPlay={false}
                                                        controls={true}
                                                        width={this.state.dimensions.width}
                                                        height={(window.innerHeight * .75) + "px"}
                                                    /> :
                                                    <Player videoUrl={this.state.videoData.video_url} hlsStartPosition={this.state.videoData.hls_low_delay}
                                                        vwidth={this.state.dimensions.width} vheight={(window.innerHeight * .75) + "px"} ref={input => this.PlayerItem = input}
                                                        Adsources={this.state.videoData.Adsources} special_parameters={this.state.videoData.special_parameters}
                                                        isYoutube={this.state.videoData.isYoutube} CaptionSrc={this.state.videoData.video_vtt} auto_start={this.state.auto_start} />

                                                }

                                            </div>
                                            : null}




                                    </div>}
                                </Row>

                                <Fragment>
                                    <Row style={{ marginTop: "1%" }}>
                                        <Col md="12">
                                            <Card className="main-card mb-3" style={this.state.videoData.is_dark === true ? { backgroundColor: "#1f1f1f", color: "white" } : null}>
                                                <CardBody>
                                                    <table style={{ width: "100%" }}>
                                                        <tr >
                                                            {this.state.videoData.show_logo === true ? < td style={{ width: "8%" }}>
                                                                {this.state.videoData.logo_src !== "" ? <img ref={i => this.imgLogo = i} src={this.state.videoData.logo_src} style={{ maxWidth: "250px", maxHeight: "80px" }} onError={this.onLogoError} /> : null}
                                                            </td> : null}
                                                            <td style={(this.state.videoData.show_references === true || this.state.videoData.show_bookmarks === true || this.state.videoData.show_chat === true) ? { width: "64%", } : { width: "75%" }}>
                                                                <span style={{ fontSize: "14px" }}>{this.state.videoData.video_title}</span><br />
                                                                {this.urlify(this.state.videoData.video_desc)}
                                                            </td>
                                                            <td >
                                                                <table style={{ width: "100%" }}>
                                                                    <tr>
                                                                        {this.state.videoData.paypalButtonCode !== null && this.state.videoData.paypalButtonCode !== "" ?
                                                                            <td style={{ width: "20%" }}>
                                                                                <Label style={{
                                                                                    textAlign: "center", width: "100%", wordBreak: "break-all"
                                                                                }}>{this.state.videoData.paypalButtonCodeTitle}</Label>
                                                                                <div id="paypal_button_div" ></div>
                                                                            </td> : <td style={{ width: "0%" }}></td>}

                                                                        {this.state.videoData.channelGuid === "47a6621027" ?
                                                                            <td style={{ width: "25%", textAlign: "right" }}><Button color="primary" onClick={() => { this.setState({ showVotePopup: true, artist_name: this.state.videoData.video_owner_name }) }}>Vote</Button></td>
                                                                            : <td style={{ width: "0%" }}></td>}

                                                                        {this.state.videoData.show_download === true &&
                                                                            ((this.state.videoData.creator_id === 297 && this.state.videoData.check_free_download === "false") || this.state.videoData.video_owner_account_guid === "5cba9208") ?
                                                                            <td style={{ textAlign: "right", width: "27%" }}> <Button color="primary" onClick={this.openDownloadPayPopup}>Download Video</Button></td>
                                                                            : (this.state.videoData.show_download === true && this.state.videoData.creator_id !== 297 && this.state.videoData.video_owner_account_guid !== "5cba9208") ||
                                                                                (this.state.videoData.show_download === true && this.state.videoData.creator_id === 297 && this.state.videoData.check_free_download !== "false") ?
                                                                                <td style={{ textAlign: "right", width: "27%" }}> <Button color="primary" href={this.state.videoData.download_url}>Download Video</Button></td> : <td style={{ width: "0%" }}> </td>
                                                                        }

                                                                        {this.state.videoData.donation === true ?
                                                                            <td style={{ textAlign: "right", width: "10%" }}> <Button color="primary" onClick={this.onShowDonationClick} >Donate</Button></td> : <td style={{ width: "0%" }}> </td>}
                                                                    </tr>
                                                                    {/*  <tr ><td></td>
                                                                        <td style={{ float: "right" }}><Button color="primary" onClick={() => { this.setState({ showVotePopup: true, artist_name: this.state.videoData.video_owner_name }) }}>Vote</Button></td>
                                                                    </tr>*/}
                                                                </table>
                                                            </td>
                                                        </tr>

                                                        {this.state.downloadVideoPaymentSuccess === true ? <tr> <td style={{ textAlign: "right", width: "20%" }}></td> <td style={{ textAlign: "right", width: "80%", }}> <Alert color="success" isOpen={this.state.downloadVideoPaymentSuccess} toggle={() => { this.setState({ downloadVideoPaymentSuccess: false }) }}>Download Transaction success, please check your e-mail</Alert></td> </tr> : null}
                                                    </table>
                                                    {/* <Button color="primary" onClick={this.openDownloadPayPopup}>Download payment Video</Button>
                                                    <br />*/}
                                                    <CommentsPart videoData={this.state.videoData} commentsActiveTab={this.state.commentsActiveTab}
                                                        showMoreComments={this.showMoreComments} onDeleteCommentClick={this.onDeleteCommentClick} onCommentKeyUp={this.onCommentKeyUp}
                                                        facebook_comments_url={facebook_comments_url} commentsToggle={this.commentsToggle} onEditCommentClick={this.onEditCommentClick}
                                                        onTypeComment={this.onTypeComment} ref={i => this.commentsPart = i}
                                                        onCommentValueChanged={this.onCommentValueChanged} cancelCommentChange={this.cancelCommentChange} />
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Fragment>
                                <Fragment>
                                    {this.state.videoData.is_owner === true ? <ModalDrawer isOpened={this.state.openDrawer} onCloseDrawerClick={this.onCloseDrawerClick}
                                        videoData={this.state.videoData} videoDesignSettingDiv={this.state.videoDesignSettingDiv} onChangeSetting={this.onChangeSetting}
                                        customAccountInfo={this.state.customAccountInfo} load_video_info={this.load_video_info} toggleBlocking={this.toggleBlocking} /> : null}
                                </Fragment>
                                <CustomeSweetAlert
                                    ref={instance => { this.alertToast = instance; }}
                                    Title="Are you sure?"
                                    Show={this.state.showCustomAlert}
                                    Text={`You will not be able to recover this comment again !`}
                                    ShowCancelButton={true}
                                    ToastMessage={this.state.ToastMessage}
                                    ToastAlertType={this.state.ToastAlertType}
                                    OnConfirm={this.onDeleteComment}
                                    OnCancel={this.onCancelDeleteComment}
                                />
                                <CustomeSweetAlert

                                    Title="Are you still watching?"
                                    Show={this.state.showStillWatchingAlert}
                                    Text={"I will close in " + this.state.timerSecondes + " seconds."}
                                    OnConfirm={this.onUserStillWatching}
                                />
                                <Modal isOpen={this.state.showEndWatchingAlert} style={{ marginTop: "20%", zIndex: "999999999999999999999" }} >
                                    <ModalBody>
                                        <h5 style={{ width: "100%", textAlign: "center" }}>Thank you for watching</h5>
                                    </ModalBody>
                                </Modal>
                                <Modal isOpen={this.state.showLoginCustomAlert} style={{ marginTop: "20%", zIndex: "999999999999999999999" }} >
                                    <ModalHeader toggle={this.onCancelLogin}>
                                        Sign in
                                    </ModalHeader>
                                    <ModalBody>
                                        <label>To add comment please login with your google account</label>
                                        <br /><br />
                                        <GoogleLogin
                                            clientId="193737205428-p2igvhsuu6tepaa17odt9g9tb57isdg1.apps.googleusercontent.com"
                                            buttonText="Login with google"
                                            onSuccess={this.onSuccessresponseGoogle}
                                            onFailure={this.onErrorresponseGoogle}
                                            cookiePolicy={'single_host_origin'}
                                            isSignedIn={false}
                                            className="google_button_style"
                                            theme="dark"
                                        />
                                    </ModalBody>
                                </Modal>
                                <Modal isOpen={this.state.showChatLoginCustomAlert} style={{ marginTop: "20%", zIndex: "999999999999999999999" }} >
                                    <ModalHeader toggle={this.onCancelChatLogin}>
                                        Sign in
                                    </ModalHeader>
                                    <ModalBody>
                                        <label>To chat please login with your google account</label>
                                        <br /><br />
                                        <GoogleLogin
                                            clientId="193737205428-p2igvhsuu6tepaa17odt9g9tb57isdg1.apps.googleusercontent.com"
                                            buttonText="Login with google"
                                            onSuccess={this.onChatSuccessresponseGoogle}
                                            onFailure={this.onChatErrorresponseGoogle}
                                            cookiePolicy={'single_host_origin'}
                                            isSignedIn={false}
                                            className="google_button_style"
                                            theme="dark"
                                        />
                                    </ModalBody>
                                </Modal>
                                <Modal isOpen={this.state.showDonatePopup}>
                                    <BlockUi tag="div" blocking={this.state.DonationModalblocking} loader={<Loader active type={this.state.loaderType} />}>
                                        <ModalHeader>
                                            {this.state.videoData.video_donation_transaction === undefined
                                                || this.state.videoData.video_donation_transaction === null
                                                || this.state.videoData.video_donation_transaction === "" ?
                                                "Donation" : this.state.videoData.video_donation_transaction === "error" ? "Donate Error" : "Thanks for Your Donation"}</ModalHeader>
                                        {this.state.videoData.video_donation_transaction === undefined || this.state.videoData.video_donation_transaction === null || this.state.videoData.video_donation_transaction === "" ?
                                            < ModalBody >
                                                <FormGroup>
                                                    <Label>Enter you donation Amount</Label><br />
                                                    $ &nbsp;&nbsp;<input type="text" placeholder="00.00" onChange={this.onChangeDonationMoneyValue} />
                                                </FormGroup>
                                                <Label>Message</Label>
                                                <br />
                                                <textarea style={{ width: "100%" }} type="text" placeholder="Enter your message for the publisher" onChange={this.onChangeDonationMessage} />
                                                {this.state.videoData.donation_type === "2" ? <BuyWithCreditCard
                                                    Title="" Price={this.state.donationMoney}
                                                    payByCreditCard={this.payDonationByCreditCard} onCloseCreditCardPopup={this.onCloseCreditCardPopup} />
                                                    : <Fragment>
                                                        <br />

                                                        <Button style={{ float: "right", marginBottom: "2%" }} onClick={this.onCloseCreditCardPopup}>Cancel</Button>
                                                        <Button style={{ float: "right", marginBottom: "2%", marginRight: "1%" }} color="primary" onClick={this.payDonationWithPaypal}>Submit</Button>
                                                    </Fragment>}
                                            </ModalBody>
                                            : <Fragment>
                                                {this.state.videoData.video_donation_transaction === "error" ? <Alert color="danger" style={{ margin: "2%" }}>Error occured please contact admin it@helnix.com</Alert> : <Alert style={{ margin: "2%" }}>Donation Transaction Number : {this.state.videoData.video_donation_transaction}</Alert>}
                                                <br />
                                                <div style={{ width: "95%", }}>
                                                    <Button style={{ float: "right", marginBottom: "1%" }} color="secondary" onClick={this.onCloseCreditCardPopup}>Close</Button>
                                                </div>
                                            </Fragment>
                                        }
                                    </BlockUi>
                                </Modal>
                                <Modal isOpen={this.state.ShowAddPaypalButtonPopup} style={{ marginTop: "10%" }}>

                                    <ModalHeader>Paypal Button</ModalHeader>
                                    <ModalBody>

                                        <Label>Button Title</Label><br />
                                        <input style={{ width: "100%" }} value={this.state.videoData.paypalButtonCodeTitle} onChange={this.onChangePaypalButtonCodeTitleValue} />
                                        <br /><br />
                                        <Label>Button Code</Label>
                                        <textarea ref={input => this.paypal_code_textarea = input} id="txt_paypal_code" style={{ width: "100%", height: "150px" }} onChange={this.onChangePaypalButtonCodeValue} value={this.state.videoData.paypalButtonCode} />
                                        <div contenteditable></div>
                                    </ModalBody>
                                    <ModalFooter>
                                        {/*   <Button style={{ float: "right", marginBottom: "1%" }} color="primary" onClick={this.onPastePaypalButtonCode}>Paste</Button>*/}
                                        <Button style={{ float: "right", marginBottom: "1%" }} color="primary" onClick={this.onClearPaypalButtonCode}>Clear Code</Button>
                                        <Button style={{ float: "right", marginBottom: "1%" }} color="primary" onClick={this.onUpdatePaypalButtonCodeClick}>Save</Button>
                                        <Button style={{ float: "right", marginBottom: "1%" }} color="secondary" onClick={this.onCloseAddPaypalButtonPopup}>Close</Button>
                                    </ModalFooter>

                                </Modal>
                                <Modal isOpen={this.state.showDownloadPopup}>
                                    <ModalBody>
                                        <Nav tabs="true">
                                            < NavItem >
                                                <NavLink href="javascript:void(0);"
                                                    className={classnames({ active: this.state.BuyDownloadActiveTab === '1' })}
                                                    onClick={() =>
                                                    {
                                                        this.buyDownloadToggle('1');
                                                    }}

                                                >
                                                    Buy Download Token

                                                </NavLink>
                                            </NavItem>
                                            < NavItem >
                                                <NavLink href="javascript:void(0);"
                                                    className={classnames({ active: this.state.BuyDownloadActiveTab === '2' })}
                                                    onClick={() =>
                                                    {
                                                        this.buyDownloadToggle('2');
                                                    }}

                                                >
                                                    Purchased
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={this.state.BuyDownloadActiveTab}>
                                            <TabPane tabId="1">
                                                {this.state.videoData.download_payment_type == "2" ?
                                                    <BuyWithCreditCard Title=""
                                                        Price={this.state.downloadVideoPrice}
                                                        payByCreditCard={this.payByCreditCardForUserPayment}
                                                        onCloseCreditCardPopup={this.onCloseDownloadPayCreditCardPopup}
                                                        showEmail={true}
                                                        onChangeEmail={this.onChangeEmail}
                                                    />
                                                    : <Fragment>
                                                        <br />
                                                        <FormGroup>
                                                            <Label>Total Money : </Label><Label style={{ fontWeight: "bold" }}>&nbsp;{"$ " + this.state.downloadVideoPrice}</Label>
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <Label for="Email">Email *</Label>
                                                            <br />
                                                            <Input type="email" onChange={this.onChangePurchaseEmail} />
                                                        </FormGroup>
                                                        <Button style={{ float: "right", marginBottom: "2%" }} onClick={this.onCloseDownloadPayCreditCardPopup}>Cancel</Button>
                                                        <Button style={{ float: "right", marginBottom: "2%", marginRight: "1%" }} color="primary" onClick={this.payDownloadvideoWithPaypal}>Submit</Button>
                                                    </Fragment>}


                                            </TabPane>
                                            <TabPane tabId="2">
                                                <Label for="Email">Email *</Label>
                                                <br />
                                                <Input type="email" onChange={this.onChangePurchaseEmail} />
                                                <br />
                                                <Button style={{ float: "right", marginRight: "1%" }} color="primary" onClick={this.checkPuerchaseByEmail}>Download & Send e-mail</Button>
                                            </TabPane>

                                        </TabContent>

                                    </ModalBody>
                                    <ModalFooter>
                                        {this.state.download_video_error !== "" ? <Alert color="danger">{this.state.download_video_error}</Alert> : null}
                                    </ModalFooter>
                                </Modal>
                                <Modal isOpen={this.state.showVotePopup}>
                                    <ModalHeader>
                                        <span>AGA Channel</span><br />
                                        <span style={{ fontSize: "16px" }}>Americans Got Anointing</span>
                                    </ModalHeader>
                                    <ModalBody>
                                        <Form>
                                            <FormGroup>
                                                <Label>Name :*</Label>
                                                <Input type="text" value={this.state.voter_name} onChange={(e) => { this.setState({ voter_name: e.target.value }) }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Email :*</Label>
                                                <Input type="text" value={this.state.voter_email} onChange={(e) => { this.setState({ voter_email: e.target.value }) }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Phone :</Label><span style={{ fontSize: "10px" }}>(optinal)</span>
                                                {/*<PhoneInput value={this.state.voter_phone}  />*/}
                                                <Input type="text" value={this.state.voter_phone} onChange={this.onChangePhoneNumber} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Artist Name :*</Label>
                                                <Input type="text" value={this.state.artist_name} onChange={(e) => { this.setState({ artist_name: e.target.value }) }} defaultValue={this.state.videoData.video_owner_name} />
                                            </FormGroup>
                                        </Form>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="primary" onClick={this.onVoteClick}>Vote</Button>
                                        <Button onClick={this.onCloseVotePopup}>Cancel</Button>
                                    </ModalFooter>
                                </Modal>
                            </Container>
                        </BlockUi>
                    </ReactCSSTransitionGroup>

                </Fragment >
            );
        }
        else if (this.state.password === "true" && this.state.isPasswordCorrect === false)
        {

            return (
                <Fragment>
                    <ReactCSSTransitionGroup
                        component="div"
                        transitionName="TabsAnimation"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnter={false}
                        transitionLeave={false}>
                        <BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type={this.state.loaderType} />}>
                            <Card>
                                <CardBody className="pt-0">
                                    <Col md="10" className="mx-auto">
                                        <Card tabs="true" className="mb-3">
                                            <CardBody>
                                                <table style={{ width: "100%" }}>
                                                    <tr >
                                                        <td style={{ width: "2%" }}>
                                                            <img src={IMG01} width="100px" height="80px" />
                                                        </td>
                                                        <td style={{ width: "96%", }}>
                                                            <span style={{ marginLeft: "2%", fontSize: "14px" }}>{this.state.videoData.video_title}</span><br />
                                                            {this.urlify(this.state.videoData.video_desc)}
                                                        </td>

                                                    </tr>

                                                </table>
                                                <div style={{ marginTop: "5%" }}>
                                                    <FormGroup >
                                                        <Label >Enter Password</Label>
                                                        <Input type="password" placeholder="Video password" onChange={this.onChangePassword} />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Button color="primary" onClick={this.submitVideoPassword} style={{ display: "block", float: "right" }}>Submit</Button>
                                                    </FormGroup>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </CardBody>
                            </Card>
                        </BlockUi>
                    </ReactCSSTransitionGroup>
                </Fragment >
            );
        }
        else if (this.state.is_embed === true && this.state.password === "false" && this.state.isPasswordCorrect === true)
        {
            const height = window.innerHeight - (window.innerHeight * .01)
            return <div style={{ width: "100%" }} ref={input => this.PlayerDiv = input}>
                {this.state.videoData.video_url !== undefined ?
                    <div style={{ textAlign: "right" }}>

                        {this.state.isHLSPlayer === true ?

                            <ReactHlsPlayer
                                src={this.state.videoData.video_url}
                                autoPlay={false}
                                controls={true}
                                width={this.state.dimensions.width}
                                height={height}
                            />

                            :

                            <Player videoUrl={this.state.videoData.video_url} hlsStartPosition={this.state.videoData.hls_low_delay}
                                vwidth={this.state.dimensions.width} vheight={height} ref={input => this.PlayerItem = input}
                                Adsources={this.state.videoData.Adsources} special_parameters={this.state.videoData.special_parameters}
                                isYoutube={this.state.videoData.isYoutube} auto_start={this.state.auto_start}
                            />


                        }
                        {this.state.videoData.donation === true ?
                            <Button style={{ marginTop: "1%" }} color="primary" onClick={this.onShowDonationClick} >Donate</Button> : null}
                        <Modal isOpen={this.state.showDonatePopup}>
                            <BlockUi tag="div" blocking={this.state.DonationModalblocking} loader={<Loader active type={this.state.loaderType} />}>
                                <ModalHeader>
                                    {this.state.videoData.video_donation_transaction === undefined
                                        || this.state.videoData.video_donation_transaction === null
                                        || this.state.videoData.video_donation_transaction === "" ?
                                        "Donation" : this.state.videoData.video_donation_transaction === "error" ? "Donate Error" : "Thanks for Your Donation"}</ModalHeader>
                                {this.state.videoData.video_donation_transaction === undefined || this.state.videoData.video_donation_transaction === null || this.state.videoData.video_donation_transaction === "" ?
                                    < ModalBody >
                                        <FormGroup>
                                            <Label>Enter you donation Amount</Label><br />
                                            $ &nbsp;&nbsp;<input type="text" placeholder="00.00" onChange={this.onChangeDonationMoneyValue} />
                                        </FormGroup>
                                        <Label>Message</Label>
                                        <br />
                                        <textarea style={{ width: "100%" }} type="text" placeholder="Enter your message for the publisher" onChange={this.onChangeDonationMessage} />
                                        {this.state.videoData.donation_type === "2" ? <BuyWithCreditCard
                                            Title="" Price={this.state.donationMoney}
                                            payByCreditCard={this.payDonationByCreditCard} onCloseCreditCardPopup={this.onCloseCreditCardPopup} />
                                            : <Fragment>
                                                <br />

                                                <Button style={{ float: "right", marginBottom: "2%" }} onClick={this.onCloseCreditCardPopup}>Cancel</Button>
                                                <Button style={{ float: "right", marginBottom: "2%", marginRight: "1%" }} color="primary" onClick={this.payDonationWithPaypal}>Submit</Button>
                                            </Fragment>}
                                    </ModalBody>
                                    : <Fragment>
                                        {this.state.videoData.video_donation_transaction === "error" ? <Alert color="danger" style={{ margin: "2%" }}>Error occured please contact admin it@helnix.com</Alert> : <Alert style={{ margin: "2%" }}>Donation Transaction Number : {this.state.videoData.video_donation_transaction}</Alert>}
                                        <br />
                                        <div style={{ width: "95%", }}>
                                            <Button style={{ float: "right", marginBottom: "1%" }} color="secondary" onClick={this.onCloseCreditCardPopup}>Close</Button>
                                        </div>
                                    </Fragment>
                                }
                            </BlockUi>
                        </Modal>
                    </div>
                    : null
                }

            </div>

        }
        else
        {
            return (
                <Fragment>
                    <ReactCSSTransitionGroup
                        component="div"
                        transitionName="TabsAnimation"
                        transitionAppear={true}
                        transitionAppearTimeout={0}
                        transitionEnter={false}
                        transitionLeave={false}>
                        <BlockUi tag="div" blocking={this.state.blocking2} loader={<Loader active type={this.state.loaderType} />}>
                            <div style={{ height: "500px" }}>
                                {this.state.errorLoading === true ? < Alert color="danger" style={{ textAlign: "center" }}>Error occured please contact admin</Alert> : null}
                            </div>
                        </BlockUi>
                    </ReactCSSTransitionGroup>
                </Fragment>
            )
        }
    }
}